<mat-drawer-container class="lum-c-sales-order" hasBackdrop="false">
  <mat-drawer
    #drawer
    class="posted-orders-drawer"
    mode="over"
    position="end"
    (closed)="onKeepDrawerOpen()"
  >
    <lum-order-posted-picklist-preview
      [data]="pickingItems"
      [config]="picklistPreviewConfig"
      [loadingPicklistItems]="loadingPicklistItems || false"
      [appIntegrationAccountId]="appIntegrationAccountId"
      (closeEvent)="onClosePicklistPreviewEvent($event)"
      (quickFulfillmentFlowEvent)="onInitQuickFulfillmentEvent($event)"
      (adjustmentEntryEvent)="onCreateAdjustmentEntry($event)"
    ></lum-order-posted-picklist-preview>
  </mat-drawer>

  <mat-drawer-content autosize>
    <lum-sales-order-ag-table
      *ngIf="warehouseGroups?.length; else noWarehouseGroups"
      [latestTrackingNumber]="latestTrackingNumber"
      (createTrackingNumberEvent)="createTrackingNumberEvent.emit($event)"
      [latestOrderStatusUpdate]="latestOrderStatusUpdate"
      (setToPendingEvent)="setToPendingEvent.emit($event)"
      [latestHoldOrderUpdate]="latestHoldOrderUpdate"
      (holdOrderEvent)="holdOrderEvent.emit($event)"
      [latestPrintShippingLabelUpdate]="latestPrintShippingLabelUpdate"
      (printShippingLabelEvent)="printShippingLabelEvent.emit($event)"
      [canMarkAsShipped]="canMarkAsShipped"
      [canDeleteSalesOrder]="canDeleteSalesOrder"
      [orderStatus]="orderStatus"
      [channels]="(channels$ | async) || []"
      [tags]="tags"
      [childComponentConfigs]="childComponentConfigurations"
      [pickingItemsLatestEntry]="pickingItemsLatestEntry"
      [warehouseGroups]="warehouseGroups"
      [currentCustomFilter]="currentCustomFilter"
      [latestSalesOrderUpdate]="latestSalesOrderUpdate"
      [channelsHasPushOrderMapping]="channelsHasPushOrderMapping"
      (previewPicklistItemsEvent)="onShowPicklistItemsDrawer($event)"
      (quickFulfillmentFlowEvent)="onInitQuickFulfillmentEvent($event)"
      (adjustmentEntryEvent)="onCreateAdjustmentEntry($event)"
      (returnSelectedRowsEvent)="onReturnSelectedRows($event)"
      (isOnSyncJobs)="onSyncJobs($event)"
      (appIntegrationAccountEvent)="onGetAppIntegrationAccountId($event)"
      (onClickOrderNumberEvent)="onClickOrderNumber($event)"
      [authUserId]="authUserId"
      (agGridStateChangedEvent)="onAgGridStateChanged()"
      [ftEdiIntegrationEnabled]="ftEdiIntegrationEnabled"
      [ftApplyPresets]="ftApplyPresets"
      [ftApprovalModuleEnabled]="ftApprovalModuleEnabled"
      [ftPickAndPackEnabled]="ftPickAndPackEnabled"
      [ftRemoveWoocommerceFromChannelType]="ftRemoveWoocommerceFromChannelType"
      [ftEdi810InvoiceSyncEnabled]="ftEdi810InvoiceSyncEnabled"
    >
      <lum-ag-grid-sidemenu
        sidemenu
        [menuItems]="sideMenuItems"
        [config]="sideMenuItemConfig"
        [activeMenu]="activeFilter"
        [enableCustomFilters]="true"
        [loadingCustomFilters]="loadingCustomFilters"
        [customFilters]="customFilters"
        (setActiveMenuItemEvent)="onSetStatus($event)"
        (setFilterEvent)="onSetFilter($event)"
        (saveFilterEvent)="onSaveFilter()"
      ></lum-ag-grid-sidemenu>
    </lum-sales-order-ag-table>
    <ng-template #noWarehouseGroups></ng-template>
  </mat-drawer-content>
</mat-drawer-container>
